export const message = {
    "教学团队":"教学团队",
    "自己":"自己",
    "暂无成员":"暂无成员",
    "暂不支持给自己发送私信":"暂不支持给自己发送私信",
    "获取用户组失败组id为空":"获取用户组失败，组id为空",
    "查看聊天记录":"查看聊天记录",
    "历史":"历史",
    "获取用户ID失败":"获取用户ID失败",
    "通讯录":"通讯录",
    "通知":"通知",
    "查看旧版聊天记录":"查看旧版聊天记录",
    "暂无消息":"暂无消息",
}
